import { render, staticRenderFns } from "./addXuanchuanDialog.vue?vue&type=template&id=24fc9398&scoped=true"
import script from "./addXuanchuanDialog.vue?vue&type=script&lang=js"
export * from "./addXuanchuanDialog.vue?vue&type=script&lang=js"
import style0 from "./addXuanchuanDialog.vue?vue&type=style&index=0&id=24fc9398&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fc9398",
  null
  
)

export default component.exports